function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 17.75c-.41 0-.75-.34-.75-.75V7c0-.41.34-.75.75-.75 3.17 0 5.75 2.58 5.75 5.75s-2.58 5.75-5.75 5.75zm.75-9.93v8.37c1.99-.35 3.5-2.1 3.5-4.18 0-2.08-1.51-3.84-3.5-4.19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 17.75c-3.17 0-5.75-2.58-5.75-5.75S8.83 6.25 12 6.25c.41 0 .75.34.75.75v10c0 .41-.34.75-.75.75zm-.75-9.93c-1.99.35-3.5 2.1-3.5 4.18 0 2.08 1.51 3.83 3.5 4.18V7.82z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75c-.41 0-.75-.34-.75-.75v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75zm0-15c-.41 0-.75-.34-.75-.75V2c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75z"
})));